"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentsFraudService = void 0;
class DeploymentsFraudService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Flags deployment as suspicious in fraud
     * @param id
     * @param requestBody
     * @returns DeploymentResponse
     * @throws ApiError
     */
    flagDeploymentAsFraud(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/fraud/flag',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Unflag deployment as suspicious in fraud
     * @param id
     * @returns DeploymentResponse
     * @throws ApiError
     */
    unflagDeploymentAsFraud(id) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{id}/fraud/unflag',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update deployment fraud data
     * @param id
     * @param requestBody
     * @returns DeploymentResponse
     * @throws ApiError
     */
    updateDeploymentFraud(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{id}/fraud',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Calculate abuse flags on a specific deployment
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    getDeploymentAbuseFlags(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/fraud',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Upload deployments marked as fraud flags (csv)
     * @returns DeploymentsFraudUploadResponse
     * @throws ApiError
     */
    uploadDeploymentsFraud() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/fraud-upload',
        });
    }
    /**
     * Searches flagged deployments matching given criterias.
     * @param creatorId
     * @returns any Successful response
     * @throws ApiError
     */
    searchFraudFlaggedDeployments(creatorId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/fraud/search',
            query: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * Get a sub set of flagged deployments
     * @param requestBody
     * @returns FlaggedDeploymentsResponse
     * @throws ApiError
     */
    getFraudFlaggedDeployments(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/fraud',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Upload deployment fraud documents
     * @returns FileUploadResponse
     * @throws ApiError
     */
    uploadDeploymentFraudDocument() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/fraud/document',
        });
    }
}
exports.DeploymentsFraudService = DeploymentsFraudService;
